import type { DisplayPublic } from '../api';
import { ChannelChrome } from './ChannelChrome';

export function AuxClockChannel({
  display,
  connected,
  onUnpair,
}: {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
}) {
  return (
    <ChannelChrome
      display={display}
      connected={connected}
      onUnpair={onUnpair}
      variant="minimal"
    >
      <div className="flex flex-1 items-center justify-center">
        <div className="text-center">
          <div className="font-mono text-[20rem] font-bold leading-none text-white">
            12:00
          </div>
          <div className="mt-12 font-mono text-3xl tracking-[0.4em] text-white/40">
            QUARTER · 1
          </div>
        </div>
      </div>
    </ChannelChrome>
  );
}
